// The first value in arrays is the default value

export const USE_NPM = "npm";
export const USE_YARN = "yarn";
export const USE_OPTIONS = [USE_NPM, USE_YARN];
export const UPDATE_TO_LATEST = "latest";
export const UPDATE_TO_NON_BREAKING = "non-breaking";
export const UPDATE_TO_WANTED = "wanted";
export const UPDATE_TO_OPTIONS = [
    UPDATE_TO_LATEST,
    UPDATE_TO_NON_BREAKING,
    UPDATE_TO_WANTED,
];
export const SAVE_SMART = "smart";
export const SAVE_CARET = "caret";
export const SAVE_EXACT = "exact";
export const SAVE_OPTIONS = [SAVE_SMART, SAVE_CARET, SAVE_EXACT];
